// utils module

const Trupanion = window.Trupanion;

const fullPage = {
        pageIndex: 1,
        pageSize: 99999999,
    },
    PAGER = {
        labels: {
            first: '&lt;&lt;',
            prev: '&lt;',
            next: '&gt;',
            last: '&gt;&gt;',
        },
        classes: {
            ul: 'pager center blue',
            li: 'pager-item',
            liActive: 'active',
            liDisable: 'disabled',
            button: 'page-link',
        },
    };

const SFStateIds = {
        '01': 'AL',
        '02': 'AK',
        '03': 'AZ',
        '04': 'AR',
        '55': 'CA',
        '05': 'CA',
        '75': 'CA',
        '06': 'CO',
        '07': 'CT',
        '08': 'DE',
        '09': 'DC',
        '59': 'FL',
        '11': 'GA',
        '51': 'HI',
        '12': 'ID',
        '13': 'IL',
        '14': 'IN',
        '15': 'IA',
        '16': 'KS',
        '17': 'KY',
        '18': 'LA',
        '19': 'ME',
        '20': 'MD',
        '21': 'MA',
        '22': 'MI',
        '23': 'MN',
        '24': 'MS',
        '25': 'MO',
        '26': 'MT',
        '27': 'NE',
        '28': 'NV',
        '29': 'NH',
        '30': 'NJ',
        '31': 'NM',
        '32': 'NY',
        '52': 'NY',
        '33': 'NC',
        '34': 'ND',
        '35': 'OH',
        '36': 'OK',
        '37': 'OR',
        '38': 'PA',
        '39': 'RI',
        '40': 'SC',
        '41': 'SD',
        '42': 'TN',
        '43': 'TX',
        '53': 'TX',
        '44': 'UT',
        '45': 'VT',
        '46': 'VA',
        '47': 'WA',
        '48': 'WV',
        '49': 'WI',
        '50': 'WY',
    },
    SFStateNames = {
        AK: 'Alaska',
        AL: 'Alabama',
        AR: 'Arkansas',
        AZ: 'Arizona',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DC: 'Washington, DC',
        DE: 'Delaware',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        IA: 'Iowa',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        MA: 'Massachusetts',
        MD: 'Maryland',
        ME: 'Maine',
        MI: 'Michigan',
        MN: 'Minnesota',
        MO: 'Missouri',
        MS: 'Mississippi',
        MT: 'Montana',
        NC: 'North Carolina',
        ND: 'North Dakota',
        NE: 'Nebraska',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NV: 'Nevada',
        NY: 'New York',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VA: 'Virginia',
        VT: 'Vermont',
        WA: 'Washington',
        WI: 'Wisconsin',
        WV: 'West Virginia',
        WY: 'Wyoming',
    },
    stateId = (code) => SFStateIds[code] || '',
    stateCode = (code) => String(code || '').slice(0,2),
    stateName = (code) => SFStateNames[code] || '',
    stateCodesForAbbr = (abbr) => Object.keys(SFStateIds).filter(code => SFStateIds[code] === abbr),
    allStates = Object.keys(SFStateNames)
        .sort((a,b) => SFStateNames[a].localeCompare(SFStateNames[b]))
        .map(abbr => ({ value: abbr, label: SFStateNames[abbr] }));

function pageSpinner(incr) {
    document.body.dispatchEvent(new CustomEvent('loading',{detail: incr}));
}

const Utils = {
    allStates: allStates,
    fullPage: fullPage,
    PAGER: PAGER,
    pageSpinner: pageSpinner,
    stateIds: SFStateIds,
    stateNames: SFStateNames,
    stateId: stateId,
    stateCode: stateCode,
    stateCodesForAbbr: stateCodesForAbbr,
    stateName: stateName,
};
Trupanion.SFAdmin.Utils = Utils;

export { Utils };
